import { wrapReducer } from "@client/content/lib/helper";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type CreateAnswerSuccessActionData, type InitSuccessActionData } from "./actions";
import { type MemberSurvey } from "./types";

const reducer = (state: MemberSurvey.AppState = defaultState, action: ReduxAction<any>): MemberSurvey.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const { answers, questions } = action.data as InitSuccessActionData;
      return {
        ...state,
        answers,
        questions,
        status: "Ready"
      };
    }
    case Actions.CreateUserFeedbackBegin: {
      return {
        ...state,
        status: "Creating"
      };
    }
    case Actions.CreateUserFeedbackFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.CreateUserFeedbackSuccess: {
      const { userTicketFeedbacks } = action.data as CreateAnswerSuccessActionData;
      return {
        ...state,
        answers: userTicketFeedbacks,
        status: "Ready"
      };
    }

    case Actions.UpdateUserFeedbackBegin: {
      return {
        ...state,
        status: "Updating"
      };
    }
    case Actions.UpdateUserFeedbackFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.UpdateUserFeedbackSuccess: {
      const { userTicketFeedbacks } = action.data as CreateAnswerSuccessActionData;
      return {
        ...state,
        answers: userTicketFeedbacks,
        status: "Ready"
      };
    }

    default:
      return state;
  }
};

export const defaultState: MemberSurvey.AppState = {
  error: null,
  id: "",
  status: "None",
  questions: [],
  answers: []
};
export const previewState: MemberSurvey.AppState = {
  ...defaultState,
  status: "Ready",
  questions: [],
  answers: []
};
export default wrapReducer({ defaultState, reducer, previewState });
